<div class="modal-header" appCustomAutofocus style="padding-top: 10px; padding-bottom: 10px;">
    <h3>I-9 Audit Report Selection Criteria</h3>
</div>

<div id="modal">
    <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
    <label><strong>Please wait while the list of employees with an I9 is obtained...</strong></label>
</div>

<div style="display: grid; grid-template-columns: 50% 50%; max-height: 600px; grid-template-rows: 600px">
    <div style="grid-column: 1; overflow-x: auto; scrollbar-width: auto; overflow-y: hidden; border-right: lightgrey solid 1px;">
        <label class="audit-label prevent-select" style="margin: 5px 0px 5px 12px;"><strong>Invitiation Date:</strong></label>
        <div style="display: flex; margin-left: 12px;">
            <div class="col-md-5" style="margin-bottom:5px; padding: 0px; min-width: 160px">
                <div class="input-group">
                    <input name="invitiation-date-start"
                           type="text"
                           class="form-control"
                           bsDatepicker
                           #frominvitiationdp="bsDatepicker"
                           [(ngModel)]="formData.invitiationStartDate"
                           [outsideClick]="true"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           (ngModelChange)="applyFilter()"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="frominvitiationdp.show()"
                                [attr.aria-expanded]="frominvitiationdp.isOpen">
                            <i class="modus-icons align-bottom">calendar</i>
                        </button>
                    </div>
                </div>
            </div>
            <label class="audit-label prevent-select" style="padding-top:7px"><strong>to</strong></label>
            <div class="col-md-5" style="margin-bottom: 5px; padding: 0px; min-width: 160px">
                <div class="input-group">
                    <input name="invitiation-date-end"
                           type="text"
                           class="form-control"
                           bsDatepicker
                           #toinvitiationdp="bsDatepicker"
                           [(ngModel)]="formData.invitiationEndDate"
                           [outsideClick]="true"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           (ngModelChange)="applyFilter()"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="toinvitiationdp.show()"
                                [attr.aria-expanded]="toinvitiationdp.isOpen">
                            <i class="modus-icons align-bottom">calendar</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <label class="audit-label prevent-select" style="margin: 5px 0px 5px 12px;"><strong>Expected/Hired Date:</strong></label>
        <div style="display: flex; margin-left: 12px;">
            <div class="col-md-5" style="margin-bottom: 5px; padding: 0px; min-width: 160px">
                <div class="input-group">
                    <input name="hired-date-start"
                           type="text"
                           class="form-control"
                           bsDatepicker
                           #fromhireddp="bsDatepicker"
                           [(ngModel)]="formData.hiredStartDate"
                           [outsideClick]="true"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           (ngModelChange)="applyFilter()"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="fromhireddp.show()"
                                [attr.aria-expanded]="fromhireddp.isOpen">
                            <i class="modus-icons align-bottom">calendar</i>
                        </button>
                    </div>
                </div>
            </div>
            <label class="audit-label prevent-select" style="padding-top: 7px;"><strong>to</strong></label>
            <div class="col-md-5" style="margin-bottom: 5px; padding: 0px; min-width: 160px">
                <div class="input-group">
                    <input name="hired-date-end"
                           type="text"
                           class="form-control"
                           bsDatepicker
                           #tohireddp="bsDatepicker"
                           [(ngModel)]="formData.hiredEndDate"
                           [outsideClick]="true"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           (ngModelChange)="applyFilter()"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="tohireddp.show()"
                                [attr.aria-expanded]="tohireddp.isOpen">
                            <i class="modus-icons align-bottom">calendar</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="audit-row cols-lg-4">
            <label class="audit-label prevent-select"><strong>Profile:</strong></label>
            <ng-select name="profile"
                       style="flex-grow: 100; min-width: 300px;"
                       [(ngModel)]="formData.profile"
                       (ngModelChange)="applyFilter()"
                       [searchable]="true"
                       [clearable]="true"
                       dropdownPosition="bottom">
                <ng-option *ngFor="let data of profiles" [value]="data.OnboardProfileID">{{data.OnboardProfileName}}</ng-option>
            </ng-select>
        </div>

        <div class="audit-row cols-lg-4">
            <label class="audit-label prevent-select"><strong>Hiring Location:</strong></label>
            <ng-select name="hiring-location"
                       style="flex-grow: 100; min-width: 250px;"
                       [(ngModel)]="formData.hiringLocation"
                       (ngModelChange)="applyFilter()"
                       [searchable]="true"
                       [clearable]="true"
                       dropdownPosition="bottom">
                <ng-option *ngFor="let data of hiringLocations" [value]="data.OnboardLocationID">{{data.OnboardLocationName}}</ng-option>
            </ng-select>
        </div>

        <div class="audit-row cols-lg-4" style="width: 350px">
            <label class="audit-label prevent-select"><strong>Status:</strong></label>
            <ng-select name="status"
                       style="flex-grow: 100; min-width: 290px;"
                       [(ngModel)]="formData.status"
                       (ngModelChange)="applyFilter()"
                       [searchable]="false"
                       [clearable]="true"
                       dropdownPosition="bottom">
                <ng-option *ngFor="let data of statuses" [value]="data.OnboardStatus">{{data.Description}}</ng-option>
            </ng-select>
        </div>

        <div class="audit-row cols-lg-4" style="width: 300px">
            <label class="audit-label prevent-select"><strong>I9 Completed by Employer:</strong></label>
            <ng-select name="i9-completed-employer"
                        class="dropdown-small"                       
                        style="flex-grow: 100; min-width: 100px;"
                        [(ngModel)]="formData.i9CompletedEmployer"
                        (ngModelChange)="applyFilter()"
                        [searchable]="false"
                        [clearable]="true"
                        dropdownPosition="bottom">
                <ng-option value="Y">Yes</ng-option>
                <ng-option value="N">No</ng-option>
            </ng-select>
        </div>

        <hr style="margin: 10px 0px 10px 0px; background-color: lightgray; ">

        <div class="audit-row cols-lg-4">
            <input type="text"
                   placeholder="Search Employees..."
                   style="width: 100%; min-width: 360px"
                   [(ngModel)]="formData.employeeFilter"
                   (ngModelChange)="applyFilter()" />
        </div>

        <div style="display: grid;" [ngStyle]="{'grid-template-rows': mobileMode ? 'auto 150px' : 'auto 170px' }">
            <div style="grid-row: 1; display: flex; justify-content: flex-end; margin: 3px 5px 5px 0px;">
                <button type="button" class="btn audit-select-button" style="margin-right: 0px; padding-right: 0px;" [disabled]="filteredEmployees.length == selectedFilterOnboardIds.size" (click)="selectionFilterEmployees(true)">Select All</button>
                <button type="button" class="btn audit-select-button" style="margin-left: 15px; margin-right: auto" [disabled]="selectedFilterOnboardIds.size == 0" (click)="selectionFilterEmployees(false)">Deselect All</button>
                <button type="button" class="fa fa-caret-right btn btn-outline-primary" style="font-size: 20px;" ngbTooltip="Add to Report List" [disabled]="selectedFilterOnboardIds.size == 0" (click)="addToReportList()"></button>
            </div>

            <ul class="audit-ul" style="grid-row: 2">
                <li class="audit-li prevent-select" *ngFor="let data of filteredEmployees"
                    [ngClass]="{'filter-item-selected': isItemSelected(selectedFilterOnboardIds, data.OnboardID)}"
                    (click)="toggleItemSelection(selectedFilterOnboardIds, data.OnboardID)">
                    {{employeeNameDisplay(data)}}
                </li>
            </ul>
        </div>
    </div>

    <div style="grid-column: 2; overflow-x: auto; scrollbar-width: auto; overflow-y: hidden;">
        <div style="display: grid">
            <div style="display: grid; grid-template-rows: 40px auto 500px">
                <div style="display: flex; flex-wrap: nowrap; grid-row: 1; margin: 10px 15px 0px 15px;">
                    <label class="prevent-select" style="color: #006638;"><strong>Audited I9s included in Report:</strong></label>
                    <label class="prevent-select" style="padding-left: 5px; color: #006638;">{{reportEmployees.length > 0 ? reportEmployees.length : employeesWithI9.length}}</label>
                </div>

                <div style="grid-row: 2; display: flex; justify-content: flex-end; margin: 8px 5px 5px 0px;">
                    <button type="button" class="btn audit-select-button" style="margin-right: 0px; padding-right: 0px;" [disabled]="reportEmployees.length == selectedReportOnboardIds.size" (click)="selectionReportEmployees(true)">Select All</button>
                    <button type="button" class="btn audit-select-button" style="margin-left: 15px; margin-right: auto" [disabled]="selectedReportOnboardIds.size == 0" (click)="selectionReportEmployees(false)">Deselect All</button>
                    <button type="button" class="fa fa-trash btn btn-outline-danger" style="font-size: 20px;" ngbTooltip="Remove from Report List" [disabled]="selectedReportOnboardIds.size == 0" (click)="removeFromReportList()"></button>
                </div>

                <ul *ngIf="reportEmployees.length > 0" class="audit-ul" style="grid-row: 3">
                    <li class="audit-li prevent-select" *ngFor="let data of reportEmployees"
                        [ngClass]="{'report-item-selected': isItemSelected(selectedReportOnboardIds, data.OnboardID)}"
                        (click)="toggleItemSelection(selectedReportOnboardIds, data.OnboardID)">
                        {{employeeNameDisplay(data)}}
                    </li>
                </ul>

                <ul *ngIf="reportEmployees.length == 0" class="audit-ul" style="grid-row: 3">
                    <li class="audit-li prevent-select" style="font-weight: bold;">{{allEmployeesPlaceholder}}</li>
                </ul>

            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" aria-hidden="true" [disabled]="this.reportEmployees.length == 0 && this.employeesWithI9.length == 0" (click)="generateReportClicked()">Generate Report</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>
